(function ($, Drupal, drupalSettings) {
	'use strict';

	const root = document.querySelector(`.layout-container.intranet`) || null;

	const handleFav = (el, classAdd, classRemove, title) => {
		el.classList.add(classAdd);
		el.setAttribute(`title`, title);
		el.querySelector(`.sr-only`).innerHTML = title;
		el.classList.remove(classRemove);
	};

	const addToFavs = () => {
		const favButton = root.querySelector(`.toggle-favori`) || null;

		if (favButton) {
			favButton.addEventListener(`click`, (e) => {
				e.preventDefault();
				fetch(`${favButton.href}`)
					.then((response) => {
						if (response.ok) {
							return response.json();
						}
					})
					.then((responseJson) => {
						favButton.classList.contains(`add-favori`)
							? handleFav(
									favButton,
									`remove-favori`,
									`add-favori`,
									`Supprimer des favoris`
							  )
							: handleFav(
									favButton,
									`add-favori`,
									`remove-favori`,
									`Ajouter aux favoris`
							  );
						// Do something with the response
						const alert = document.createElement(`p`);
						alert.classList.add(`alert-appointment`);
						alert.setAttribute(`role`, `alert`);
						alert.textContent = responseJson.msg;
						if (!responseJson.success) {
							alert.classList.add(`unsucceed`);
						} else {
							alert.classList.add(`succeed`);
						}

						document
							.querySelector(`body`)
							.insertAdjacentElement(`beforeend`, alert);

						setTimeout(() => {
							alert.classList.add(`close`);
						}, 4000);

						alert.addEventListener(`animationend`, (e) => {
							if (e.animationName === `fade-out-down`) {
								alert.remove();
							}
						});
					})
					.catch((error) => {
						console.log(error);
					});
			});
		}
	};
	const refactoLoginPage = () => {
		const isLoginPage =
			document.querySelector(`.user-login-form`) ||
			document.querySelector(`.form__item-charte`) ||
			document.querySelector(`.user-pass`);
		if (isLoginPage) {
			const banner = document.querySelector(`.banner`);
			const main = document.querySelector(`main`);
			const breadcrumb = document.querySelector(`.nav-tools`);
			main.classList.add(`main-nologged`);
			breadcrumb?.classList.add(`nav-tools--disabled`);
			document
				.querySelector(`body`)
				.insertAdjacentHTML(
					`afterbegin`,
					`<div class="intranet-login__visuel"></div>`
				);
			main.insertAdjacentElement(`afterbegin`, banner);
			document.querySelector(`header`).classList.add(`intranet-nologged`);
			document.querySelector(`footer`)?.classList.add(`intranet-nologged`);

			if (document.querySelector(`.user-pass`)) {
				document
					.querySelector(`.user-pass`)
					.classList.add(`module`, `shadow`);
			}
		}
	};
	const init = () => {
		if (root) {
			addToFavs();
		}
		refactoLoginPage();
	};

	init();

	Drupal.behaviors.exposedFormCustom = {
		attach: function (context, drupalSettings) {
			const bsBreakpoint = bsBreakpoints.detectBreakpoint();

			// Vars
			const root = document.querySelector(`.view-filters`);

			// Functions
			const ddFilters = () => {
				const fieldsets = root.querySelectorAll(
					`fieldset:not(.remove)`
				);
				fieldsets.forEach((el) => {
					el.querySelectorAll(`legend`).forEach((element) => {
						element.insertAdjacentHTML(
							`beforeend`,
							`<button type="button" class="filters-toggle filters-toggle--close"><i class="filters-toggle__icon" data-icon="chevron"></i><span class="sr-only">${
								element.querySelector(`.fieldset-legend`)
									.innerHTML
							}</span></button>`
						);
					});
				});
			};

			const toggle = () => {
				const filters = root.querySelectorAll(`fieldset:not(.remove)`);
				const wrappers = root.querySelectorAll(`legend`);

				wrappers.forEach((el, key) => {
					el.addEventListener(`click`, (e) => {
						if (el.parentNode.classList.contains(`active`)) {
							el.parentNode.classList.remove(`active`);
						} else {
							filters.forEach((filter) => {
								filter.classList.remove(`active`);
							});
							el.parentNode.classList.add(`active`);

							if (bsBreakpoint === `xSmall`) {
								el.scrollIntoView({
									block: `center`,
									behavior: `smooth`,
								});
							}
						}
						a11y();
					});
				});
			};

			// add style when fieldset has options checked or text value (date or address)
			const selectedOptions = () => {
				setTimeout(function () {
					const fieldsets = root.querySelectorAll(`fieldset`);
					fieldsets.forEach((fieldset) => {
						const inputs = fieldset.querySelectorAll(`input`);
						inputs.forEach((el) => {
							const isChecked = el.getAttribute(`checked`);
							const type =
								(el.type === `text` || el.type === `date`) &&
								el.value != ``;
							const isNotRadio = el.type !== `radio`;
							const isNotRemoved =
								!fieldset.classList.contains(`remove`);

							if (
								(isChecked && isNotRemoved && isNotRadio) ||
								type
							) {
								fieldset.classList.add(`selected`);
							}

							// add style on form-group for field position distance when checked
							if (
								el.classList.contains(
									`field-position-distance-from-wrapper`
								) &&
								isChecked
							) {
								el.parentNode.parentNode.classList.add(
									`checked`
								);
							}
						});
					});
				}, 0);
			};

			const searchFilter = () => {};

			// Reconstruction de la structure HTML pour gérer l'apparence des filtres en version mobile
			const mobileFilters = () => {
				const exposedForm = root.querySelector(`.views-exposed-form`);
				exposedForm.insertAdjacentHTML(
					`beforeend`,
					`<div class="fieldsets"></div>`
				);
				root.insertAdjacentHTML(
					`beforeend`,
					`<div data-filters-toggle="" class="filters-toggle-btn">
                                                <i data-icon="filters"></i>
                                                <i data-icon="cross"></i>
                                                <span>${ModuloTS.Filter}</span>
                                              </div>`
				);

				const btnFilter = root.querySelector(`[data-filters-toggle]`);
				const fieldsets = root.querySelectorAll(
					`fieldset:not(.remove)`
				);
				const container = root.querySelector(`.fieldsets`);
				fieldsets.forEach((el) => {
					container.appendChild(el);
				});

				btnFilter.addEventListener(`click`, () => {
					container.classList.toggle(`expanded`);
					btnFilter.classList.toggle(`expanded`);
				});
			};

			// permet de garder le filtre ouvert grace au localstorage
			// on paramètre le path et le data drupal selector du fieldset sur lequel on filtre
			const filterStorage = () => {
				const fieldsets = root.querySelectorAll(
					`.fieldset-wrapper button, .fieldset-wrapper input `
				);

				fieldsets.forEach((el) => {
					el.addEventListener(`keydown`, (e) => {
						if (el.type != `button`) {
							if ((e.keyCode ? e.keyCode : e.which) == 13) {
								el.checked = !el.checked;
								setLocalStorage(el);
							}
						}
					});

					el.addEventListener(`click`, () => {
						setLocalStorage(el);
					});
				});

				const setLocalStorage = (el) => {
					const parentFieldset = el
						.closest(`fieldset:not(.remove)`)
						.getAttribute(`data-drupal-selector`);
					localStorage.setItem(
						`activeFilter`,
						JSON.stringify([
							window.location.pathname,
							parentFieldset,
						])
					);
					if (el.tagName === `INPUT`) {
						localStorage.setItem(
							`activeInput`,
							JSON.stringify([el.type, el.name, el.value])
						);
					} else {
						localStorage.setItem(
							`activeInput`,
							JSON.stringify([el.type, `locate-me`])
						);
					}
				};

				// si on a le localstorage correspondant au nom du filtre et du path, on ouvre le filtre
				if (
					localStorage.getItem(`activeFilter`) &&
					JSON.parse(localStorage.activeFilter)[0] ==
						window.location.pathname
				) {
					const activeFilter = root.querySelector(
						`[data-drupal-selector=${
							JSON.parse(localStorage.activeFilter)[1]
						}]`
					);
					root.querySelector(`.fieldsets`).classList.add(`expanded`);
					root.querySelector(`[data-filters-toggle]`).classList.add(
						`expanded`
					);
					document.body.classList.add(`fixed`);
					activeFilter.classList.add(`active`);
				}
			};

			// on remove le localstorage du filtre au click sur le bouton fermer en mobile
			const removeStorage = () => {
				const btnExpanded = root.querySelector(
					`[data-filters-toggle].expanded`
				);
				if (btnExpanded) {
					btnExpanded.addEventListener(`click`, () => {
						localStorage.removeItem(`activeFilter`);
						document.body.classList.remove(`fixed`);
					});
				}
			};

			const a11y = () => {
				const fieldsets = root.querySelectorAll(`legend`);

				fieldsets.forEach((fieldset) => {
					let inputType, inputName, inputValue;
					const buttonFilter =
						fieldset.querySelector(`.filters-toggle`);
					if (fieldset.parentNode.classList.contains(`active`)) {
						buttonFilter.ariaExpanded = `true`;
					} else {
						buttonFilter.ariaExpanded = `false`;
					}

					const locate = document.querySelector(`button.locate-me`);

					if (localStorage.getItem(`activeInput`) === null) {
						inputType = null;
						inputName = null;
						inputValue = null;
					} else {
						inputType = JSON.parse(localStorage.activeInput)[0];
						inputName = JSON.parse(localStorage.activeInput)[1];
						inputValue = JSON.parse(localStorage.activeInput)[2];
					}
					const input =
						inputType === `radio`
							? document.querySelector(
									`[name="${inputName}"][value="${inputValue}"]`
							  )
							: document.querySelector(`[name="${inputName}"]`);
					const lastFocusable =
						inputName === `locate-me` ? locate : input;
					if (lastFocusable) {
						lastFocusable.focus();
					}
				});
			};

			// ajouter un parent au submit pour lui attribuer des classes avec pseudo elements pour spe (ex tournai, pavillons)
			// le fait pour les autres input type submit dans js/submits.js
			const setSubmitStyle = () => {
				// SI changement à impaxter égalmeent dans
				const submit = root.querySelector(`.js-form-submit`);

				submit.classList.remove(`form-control-lg`, `form-control`);
				submit.classList.add(`btn`, `btn-primary`);
				submit.setAttribute(`data-icon`, `arrow`);
				const wrapper = document.createElement(`div`);
				wrapper.classList.add(`btn-primary-submit`);
				submit.parentNode.insertBefore(wrapper, submit);
				wrapper.appendChild(submit);
			};

			// AJoute des titles aux inputs
			const addTitleInput = () => {
				const inputs = document.querySelectorAll(`.fieldsets input`);

				inputs.forEach((input) => {
					const titleLabel =
						document.querySelector(`label[for="${input.id}"]`) ||
						null;
					if (titleLabel) {
						input.setAttribute(
							`title`,
							`${titleLabel.innerHTML} - ${
								ModuloTS[`The selection updates the results`]
							}`
						);
					}
				});
			};

			// GO après chargement 🚀
			$(once(`viewFilters`, `.view-filters`, context)).each(function () {
				if (root !== null && root !== undefined) {
					ddFilters();
					setSubmitStyle();
					toggle();
					searchFilter();
					mobileFilters();
					selectedOptions();
					filterStorage();
					removeStorage();
					a11y();
					addTitleInput();
				}
			});
		},
	};
})(jQuery, Drupal, drupalSettings);
